import { useEffect, useState } from "react";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Typography,
    IconButton,
    Stack,
} from "@mui/material";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";


const EditarBanner = ({
    open,
    onClose,
    onSubmit,
    banner,
    loading,
}) => {

    const backendURL =
        process.env.REACT_APP_BACKEND_URL;


    const [titulo, setTitulo] = useState("");
    const [descripcion, setDescripcion] =
        useState("");

    const [link, setLink] = useState("");

    const [nameButton, setNameButton] =
        useState("");

    const [posicion, setPosicion] =
        useState("");

    const [imagen, setImagen] =
        useState(null);

    const [preview, setPreview] =
        useState(null);


    /*
    |--------------------------------------------------------------------------
    | CARGAR DATOS DEL BANNER
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        if (!banner) return;

        setTitulo(
            banner.titulo || ""
        );

        setDescripcion(
            banner.descripcion || ""
        );

        setLink(
            banner.link || ""
        );

        setNameButton(
            banner.name_button || ""
        );

        setPosicion(
            banner.posicion || ""
        );


        if (banner.imagen) {

            setPreview(
                `${backendURL}/${banner.imagen}`
            );

        }

    }, [banner, backendURL]);


    /*
    |--------------------------------------------------------------------------
    | IMAGEN
    |--------------------------------------------------------------------------
    */

    const handleImagen = (event) => {

        const file =
            event.target.files[0];

        if (!file) return;

        setImagen(file);

        setPreview(
            URL.createObjectURL(file)
        );

    };


    /*
    |--------------------------------------------------------------------------
    | GUARDAR CAMBIOS
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async () => {

        if (!banner) return;


        const formData =
            new FormData();


        formData.append(
            "titulo",
            titulo
        );

        formData.append(
            "descripcion",
            descripcion
        );

        formData.append(
            "link",
            link
        );

        formData.append(
            "name_button",
            nameButton
        );

        formData.append(
            "posicion",
            posicion
        );


        /*
        | Solo enviamos imagen si
        | seleccionó una nueva
        */

        if (imagen) {

            formData.append(
                "imagen",
                imagen
            );

        }


        await onSubmit(
            banner.id,
            formData
        );

    };


    /*
    |--------------------------------------------------------------------------
    | CERRAR
    |--------------------------------------------------------------------------
    */

    const handleClose = () => {

        setImagen(null);

        setPreview(null);

        onClose();

    };


    if (!banner) {
        return null;
    }


    return (

        <Dialog
            open={open}
            onClose={handleClose}

            fullWidth
            maxWidth="md"
        >

            {/* HEADER */}

            <DialogTitle
                sx={{
                    px: 4,
                    pt: 3,

                    fontWeight: 800,

                    color: "#12213F",

                    fontFamily: "Archivo",
                }}
            >

                Editar banner

                <IconButton
                    onClick={handleClose}

                    sx={{
                        position:
                            "absolute",

                        right: 18,
                        top: 18,

                        color: "#687083",
                    }}
                >

                    <CloseRoundedIcon />

                </IconButton>

            </DialogTitle>


            <DialogContent
                sx={{
                    px: {
                        xs: 3,
                        md: 4,
                    },

                    pb: 2,
                }}
            >

                <Stack spacing={2.5}>


                    {/* ================================================= */}
                    {/* IMAGEN */}
                    {/* ================================================= */}

                    <Box>

                        <Typography
                            sx={{
                                mb: 1,

                                fontWeight: 700,

                                color:
                                    "#12213F",
                            }}
                        >
                            Imagen
                        </Typography>


                        {preview && (

                            <Box
                                component="img"
                                src={preview}

                                sx={{
                                    width: "100%",

                                    height: 220,

                                    objectFit:
                                        "cover",

                                    borderRadius:
                                        "16px",

                                    mb: 2,
                                }}
                            />

                        )}


                        <Button
                            component="label"

                            variant="outlined"

                            startIcon={
                                <CloudUploadRoundedIcon />
                            }

                            sx={{
                                borderRadius:
                                    "12px",

                                textTransform:
                                    "none",

                                fontWeight: 700,

                                color:
                                    "#484a75",

                                borderColor:
                                    "#d8dce5",
                            }}
                        >

                            Cambiar imagen

                            <input
                                hidden

                                type="file"

                                accept="image/*"

                                onChange={
                                    handleImagen
                                }
                            />

                        </Button>

                    </Box>


                    {/* TITULO */}

                    <TextField
                        label="Título"

                        value={titulo}

                        onChange={(e) =>
                            setTitulo(
                                e.target.value
                            )
                        }

                        fullWidth
                    />


                    {/* DESCRIPCIÓN */}

                    <TextField
                        label="Descripción"

                        value={descripcion}

                        onChange={(e) =>
                            setDescripcion(
                                e.target.value
                            )
                        }

                        fullWidth

                        multiline
                        rows={4}
                    />


                    {/* LINK */}

                    <TextField
                        label="Link"

                        value={link}

                        onChange={(e) =>
                            setLink(
                                e.target.value
                            )
                        }

                        fullWidth
                    />


                    {/* BOTÓN */}

                    <TextField
                        label="Nombre del botón"

                        value={nameButton}

                        onChange={(e) =>
                            setNameButton(
                                e.target.value
                            )
                        }

                        fullWidth
                    />


                    {/* POSICIÓN */}

                    <TextField
                        label="Posición"

                        type="number"

                        value={posicion}

                        onChange={(e) =>
                            setPosicion(
                                e.target.value
                            )
                        }

                        fullWidth
                    />

                </Stack>

            </DialogContent>


            <DialogActions
                sx={{
                    px: 4,
                    pb: 3,
                }}
            >

                <Button
                    onClick={handleClose}

                    sx={{
                        textTransform:
                            "none",

                        fontWeight: 700,

                        color:
                            "#687083",
                    }}
                >
                    Cancelar
                </Button>


                <Button
                    variant="contained"

                    disabled={loading}

                    onClick={
                        handleSubmit
                    }

                    sx={{
                        borderRadius:
                            "12px",

                        px: 3,

                        py: 1.2,

                        textTransform:
                            "none",

                        fontWeight: 700,

                        background:
                            "linear-gradient(135deg,#C62828,#8f1515)",

                        boxShadow: "none",
                    }}
                >

                    {loading
                        ? "Guardando..."
                        : "Guardar cambios"}

                </Button>

            </DialogActions>

        </Dialog>

    );
};


export default EditarBanner;